document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const update = () => {
    const opened = drawer.hasAttribute('open') || drawer.classList.contains('is-open');
    document.documentElement.classList.toggle('drawer-open', opened);
  };

  // следим за открытием/закрытием (атрибут open / класс is-open)
  const mo = new MutationObserver(update);
  mo.observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });

  // на случай завершения CSS-анимаций
  drawer.addEventListener('transitionend', update);

  update();
});
